// extracted by mini-css-extract-plugin
export default {"loding":"Lodaing_loding__3KsPK","loader":"Lodaing_loader__Kf4RA","rotate":"Lodaing_rotate__JshJu"};